import { render, staticRenderFns } from "./ElectionSettingsDialog.vue?vue&type=template&id=6027bf86&scoped=true"
import script from "./ElectionSettingsDialog.vue?vue&type=script&lang=js"
export * from "./ElectionSettingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6027bf86",
  null
  
)

export default component.exports